/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import useLeadService from 'domain/sales/lead/shared/leadService';
import { useLeadUrl } from 'domain/shared/lead';
import LeadForm from 'domain/sales/lead/createupdate/LeadForm';
import { CreateForm } from 'framework/form';
import CreateLeadBreadcrumbs from 'domain/sales/lead/createupdate/Create/Breadcrumbs';

const CreateLead = () => {
  const { create, getValidationSchema } = useLeadService();
  const { getListUrl } = useLeadUrl();

  return (
    <CreateForm
      submitFormFunc={create}
      initialData={{
        status: 'ASSIGNED',
        source: 'ORGANIC_SEARCH',
        address: {
          country: 'United States',
        },
        medium: 'WEB_FORM',
      }}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Lead has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Lead" breadcrumbs={<CreateLeadBreadcrumbs />}>
        <LeadForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateLead;
